module.exports = __webpack_public_path__ + "static/media/add.97f54f4c.svg";